

export default {
    data() {
        return {
            list_data: [],
            page_first: 1,
            page_last: 0,
            page_limit: 50,
        }
    },
    methods: {

        getView: function () {
            fetch(this.$store.state.url.URL_FAQ + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    unit_kerja: this.unit_kerja,
                    data_ke: this.page_first,
                    cari_value: this.cari_value
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_data = res_data.data;
                    this.page_last = res_data.jml_data;
                    this.cek_load_data = false;

                    // console.log(res_data);
                });
        }
    },
    mounted() {
        this.getView();
    },

}
